/* eslint-disable no-console */
export const USER_KEY = "@authenticator/user";
export const TOKEN_KEY = "@authenticator/token";
export const USER_MENU = "@authenticator/menu";
export const LOGO_KEY = "@authenticator/logo";
export const PERMISSION_KEY = "@authenticator/permission";

export const isAuthenticated = () => {
  const localToken = localStorage.getItem(TOKEN_KEY);
  const sessionToken = sessionStorage.getItem(TOKEN_KEY);

  if (!localToken && !sessionToken) {
    return false;
  } else {
    return true;
  }

  // return !token;
  // localStorage.getItem(TOKEN_KEY) !== null
};

export const getUser = () => {
  const localUser = JSON.parse(localStorage.getItem(USER_KEY));
  const sessionUser = JSON.parse(sessionStorage.getItem(USER_KEY));

  if (localUser) {
    return localUser;
  } else {
    return sessionUser;
  }
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const login = (user, token, permissions) => {
  //Sistemas antigos
  sessionStorage.setItem(USER_KEY, JSON.stringify(user));
  sessionStorage.setItem(TOKEN_KEY, token);
  sessionStorage.setItem(PERMISSION_KEY, JSON.stringify(permissions));

  //Sistemas novos
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(PERMISSION_KEY, JSON.stringify(permissions));
};

export const logout = () => {
  //Sistemas antigos
  sessionStorage.removeItem(USER_MENU);
  sessionStorage.removeItem(USER_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(PERMISSION_KEY);

  //Sistemas novos
  localStorage.removeItem(USER_MENU);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(LOGO_KEY);
  localStorage.removeItem(PERMISSION_KEY);
};
